module.exports = __webpack_public_path__ + "img/avatar5.d53508e5.png";